import SvgIcon from '@mui/material/SvgIcon'

/** Sidebar mark — flame glyph, 20×20 in 32×32 orange tile (#FF9933) */
const MARK_PATH =
  'M7.08333 12.0833C7.63587 12.0833 8.16577 11.8638 8.55647 11.4731C8.94717 11.0824 9.16667 10.5525 9.16667 10C9.16667 8.85 8.75 8.33333 8.33333 7.5C7.44 5.71417 8.14667 4.12167 10 2.5C10.4167 4.58333 11.6667 6.58333 13.3333 7.91667C15 9.25 15.8333 10.8333 15.8333 12.5C15.8333 13.266 15.6825 14.0246 15.3893 14.7323C15.0961 15.4401 14.6665 16.0831 14.1248 16.6248C13.5831 17.1665 12.9401 17.5961 12.2323 17.8893C11.5246 18.1825 10.766 18.3333 10 18.3333C9.23396 18.3333 8.47541 18.1825 7.76768 17.8893C7.05995 17.5961 6.41689 17.1665 5.87521 16.6248C5.33354 16.0831 4.90386 15.4401 4.6107 14.7323C4.31755 14.0246 4.16667 13.266 4.16667 12.5C4.16667 11.5392 4.5275 10.5883 5 10C5 10.5525 5.21949 11.0824 5.61019 11.4731C6.0009 11.8638 6.5308 12.0833 7.08333 12.0833Z'

export function BrushfireMarkIcon() {
  return (
    <SvgIcon
      viewBox="0 0 20 20"
      sx={{
        fontSize: 20,
        width: 20,
        height: 20,
        display: 'block',
        color: '#ffffff',
      }}
    >
      <path
        d={MARK_PATH}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={1.66667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
